module.exports = __webpack_public_path__ + "static/coinview-01cf430f8a1e88a33a56d561e5bbb0d2.png";